import Box from '@redbubble/design-system/src/Box';
import * as constants from '@redbubble/design-system/src/constants';
import Skeleton from '@redbubble/design-system/src/Skeleton';
import Stack from '@redbubble/design-system/src/Stack';
import styles from './SearchResultsGrid.module.scss';

export const SearchResultsGridSkeleton: React.FC<{ limit?: number }> = ({
  limit = 100,
}) => {
  return (
    <Box className={styles.grid} data-testid="search-results-grid-skeleton">
      {Array.from({ length: limit })
        .fill('')
        .map((_, i) => {
          return (
            <Box
              // biome-ignore lint/suspicious/noArrayIndexKey: noArrayIndexKey
              key={i}
            >
              <Skeleton
                ratio={constants.RATIO_SQUARE}
                animated
                roundedCorners
              />

              <Box paddingTop="s">
                <Stack spacing="xxs">
                  <Skeleton height={20} width="80%" animated roundedCorners />

                  <Skeleton height={20} width="70%" animated roundedCorners />
                </Stack>

                <Box paddingTop="s">
                  <Skeleton height={20} width="40%" animated roundedCorners />
                </Box>
              </Box>
            </Box>
          );
        })}
    </Box>
  );
};
